// Data for various widgets that are masked.

export const barChartData = {
  widget: {
    id: 'subscription.totalsubscriptionrevenue',
    title: 'Total Subscription Revenue',
    updated: '2024-09-09T22:23:47+00:00',
    type: 'system',
    module: {
      id: 'totalsubscriptionrevenue',
      title: 'Total Subscription Revenue',
      app: 'subscription',
      parameters: {
        startDate: {
          type: 'str',
          label: 'Start Date',
          required: false,
          multiple: false,
        },
        endDate: {
          type: 'str',
          label: 'End Date',
          required: false,
          multiple: false,
        },
        hostname: {
          type: 'str',
          label: 'Hostname',
          required: false,
          multiple: false,
        },
        refresh: '120',
      },
      data: {
        new_revenue: {
          type: 'integer',
          label: 'New Revenue',
          format: 'currency',
          currency: 'USD',
        },
        renewal_revenue: {
          type: 'integer',
          label: 'Renewal Revenue',
          format: 'currency',
          currency: 'USD',
        },
        date: {
          type: 'string',
          label: 'Date',
          date_format: 'm',
        },
      },
      display: {
        options: [
          {
            type: 'bar',
            config: {
              subtype: 'stacked',
              'x-col': 'date',
              'x-display-format': 'M',
              'y-col': {
                label: 'Total Revenue',
                fields: ['renewal_revenue', 'new_revenue'],
              },
            },
          },
        ],
        default: 'bar',
      },
    },
    parameters: {
      startDate: '-12 months',
      endDate: 'now',
      hostname: 'example.com',
      refresh: '120',
    },
    display: {
      view: 'bar',
      options: { options: [] } as any,
    },
  },
  data: {
    status: 'success',
    widget_id: 'insights.views',
    results_id: 'e25d8fb8-1904-11ef-b876-efbad47e49d3',
    total: 19,
    limit: false,
    offset: 0,
    results: [
      {
        date: '2023-10-31',
        renewal_revenue: 143,
        new_revenue: 1056,
      },
      {
        date: '2023-11-30',
        renewal_revenue: 125,
        new_revenue: 733,
      },
      {
        date: '2023-12-31',
        renewal_revenue: 84,
        new_revenue: 416,
      },
      {
        date: '2024-01-31',
        renewal_revenue: 48,
        new_revenue: 903,
      },
      {
        date: '2024-02-29',
        renewal_revenue: 70,
        new_revenue: 672,
      },
      {
        date: '2024-03-31',
        renewal_revenue: 116,
        new_revenue: 673,
      },
      {
        date: '2024-04-30',
        renewal_revenue: 104,
        new_revenue: 756,
      },
      {
        date: '2024-05-31',
        renewal_revenue: 87,
        new_revenue: 911,
      },
      {
        date: '2024-06-30',
        renewal_revenue: 86,
        new_revenue: 801,
      },
      {
        date: '2024-07-31',
        renewal_revenue: 50,
        new_revenue: 556,
      },
      {
        date: '2024-08-31',
        renewal_revenue: 40,
        new_revenue: 979,
      },
      {
        date: '2024-09-30',
        renewal_revenue: 127,
        new_revenue: 385,
      },
    ],
  },
};

export const viewsByTrafficSourceBarChartData = {
  widget: {
    id: 'editorial.viewsbytrafficsource',
    title: 'Views by Traffic Source',
    updated: '2025-03-05T19:45:50+00:00',
    type: 'system',
    module: {
      id: 'viewsbytrafficsource',
      title: 'Views by Traffic Source',
      app: 'editorial',
      parameters: {
        hostname: {
          type: 'str',
          label: 'Hostname',
          required: false,
          multiple: false,
        },
        sourceLimit: {
          type: 'integer',
          label: 'Source Limit',
          required: false,
          multiple: false,
          min: 1,
          max: 25,
          step: 1,
          default: 5,
        },
        subscriberOnly: {
          type: 'boolean',
          label: 'Subscribers Only',
          required: false,
          multiple: false,
        },
        refresh: '120',
      },
      data: {
        utc_hour: {
          type: 'string',
          label: 'UTC Hour',
        },
        views: {
          type: 'array',
          label: 'Views',
        },
      },
      display: {
        options: [
          {
            type: 'bar',
            config: {
              'x-col': 'utc_hour',
              'x-display-format': 'g a',
              'y-col': 'views',
              subtype: 'stacked',
            },
          },
        ],
        default: 'bar',
      },
    },
    parameters: {
      hostname: 'example.com',
      sourceLimit: 5,
      refresh: '120',
    },
    display: {
      view: 'bar',
      options: { options: [] } as any,
    },
    refresh: 3600,
  },
  data: {
    status: 'success',
    widget_id: 'editorial.viewsbytrafficsource',
    results_id: '80971d40-e8b5-11ef-9152-1b53951ca5c4',
    total: 24,
    limit: false,
    offset: 0,
    results: [
      {
        utc_hour: '2025-02-10T20:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 2659,
          },
          {
            source: 'google',
            views: 2466,
          },
          {
            source: 'facebook',
            views: 1686,
          },
          {
            source: 'yahoo',
            views: 814,
          },
          {
            source: 'bing',
            views: 698,
          },
        ],
      },
      {
        utc_hour: '2025-02-10T21:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 4222,
          },
          {
            source: 'google',
            views: 2143,
          },
          {
            source: 'yahoo',
            views: 859,
          },
          {
            source: 'facebook',
            views: 589,
          },
          {
            source: 'bing',
            views: 505,
          },
        ],
      },
      {
        utc_hour: '2025-02-10T22:00:00+00:00',
        views: [
          {
            source: 'google',
            views: 4768,
          },
          {
            source: '(direct)',
            views: 1282,
          },
          {
            source: 'facebook',
            views: 1227,
          },
          {
            source: 'bing',
            views: 914,
          },
          {
            source: 'yahoo',
            views: 704,
          },
        ],
      },
      {
        utc_hour: '2025-02-10T23:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 4325,
          },
          {
            source: 'google',
            views: 2789,
          },
          {
            source: 'facebook',
            views: 681,
          },
          {
            source: 'bing',
            views: 657,
          },
          {
            source: 'yahoo',
            views: 460,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T00:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 6716,
          },
          {
            source: 'google',
            views: 2065,
          },
          {
            source: 'facebook',
            views: 1974,
          },
          {
            source: 'bing',
            views: 753,
          },
          {
            source: 'yahoo',
            views: 216,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T01:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 6180,
          },
          {
            source: 'google',
            views: 3309,
          },
          {
            source: 'yahoo',
            views: 677,
          },
          {
            source: 'bing',
            views: 517,
          },
          {
            source: 'facebook',
            views: 256,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T02:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 7605,
          },
          {
            source: 'google',
            views: 1053,
          },
          {
            source: 'facebook',
            views: 877,
          },
          {
            source: 'yahoo',
            views: 413,
          },
          {
            source: 'bing',
            views: 365,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T03:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 1878,
          },
          {
            source: 'bing',
            views: 876,
          },
          {
            source: 'facebook',
            views: 745,
          },
          {
            source: 'google',
            views: 667,
          },
          {
            source: 'yahoo',
            views: 229,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T04:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 5465,
          },
          {
            source: 'google',
            views: 2645,
          },
          {
            source: 'facebook',
            views: 1935,
          },
          {
            source: 'bing',
            views: 918,
          },
          {
            source: 'yahoo',
            views: 466,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T05:00:00+00:00',
        views: [
          {
            source: 'google',
            views: 4352,
          },
          {
            source: '(direct)',
            views: 2510,
          },
          {
            source: 'facebook',
            views: 702,
          },
          {
            source: 'yahoo',
            views: 403,
          },
          {
            source: 'bing',
            views: 376,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T06:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 6176,
          },
          {
            source: 'google',
            views: 4675,
          },
          {
            source: 'facebook',
            views: 665,
          },
          {
            source: 'bing',
            views: 636,
          },
          {
            source: 'yahoo',
            views: 324,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T07:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 5414,
          },
          {
            source: 'google',
            views: 1530,
          },
          {
            source: 'facebook',
            views: 1479,
          },
          {
            source: 'yahoo',
            views: 525,
          },
          {
            source: 'bing',
            views: 175,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T08:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 5113,
          },
          {
            source: 'google',
            views: 1918,
          },
          {
            source: 'yahoo',
            views: 992,
          },
          {
            source: 'facebook',
            views: 783,
          },
          {
            source: 'bing',
            views: 679,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T09:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 8664,
          },
          {
            source: 'google',
            views: 4277,
          },
          {
            source: 'facebook',
            views: 1909,
          },
          {
            source: 'bing',
            views: 664,
          },
          {
            source: 'yahoo',
            views: 573,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T10:00:00+00:00',
        views: [
          {
            source: 'google',
            views: 4990,
          },
          {
            source: 'facebook',
            views: 1697,
          },
          {
            source: '(direct)',
            views: 1558,
          },
          {
            source: 'yahoo',
            views: 479,
          },
          {
            source: 'bing',
            views: 272,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T11:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 9249,
          },
          {
            source: 'google',
            views: 1903,
          },
          {
            source: 'facebook',
            views: 1263,
          },
          {
            source: 'bing',
            views: 596,
          },
          {
            source: 'yahoo',
            views: 361,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T12:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 7040,
          },
          {
            source: 'google',
            views: 3647,
          },
          {
            source: 'bing',
            views: 898,
          },
          {
            source: 'facebook',
            views: 269,
          },
          {
            source: 'yahoo',
            views: 119,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T13:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 4572,
          },
          {
            source: 'google',
            views: 1033,
          },
          {
            source: 'bing',
            views: 732,
          },
          {
            source: 'facebook',
            views: 583,
          },
          {
            source: 'yahoo',
            views: 547,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T14:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 7305,
          },
          {
            source: 'google',
            views: 3117,
          },
          {
            source: 'facebook',
            views: 978,
          },
          {
            source: 'bing',
            views: 481,
          },
          {
            source: 'yahoo',
            views: 365,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T15:00:00+00:00',
        views: [
          {
            source: 'google',
            views: 1718,
          },
          {
            source: '(direct)',
            views: 1320,
          },
          {
            source: 'yahoo',
            views: 818,
          },
          {
            source: 'bing',
            views: 810,
          },
          {
            source: 'facebook',
            views: 598,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T16:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 4279,
          },
          {
            source: 'google',
            views: 2940,
          },
          {
            source: 'yahoo',
            views: 892,
          },
          {
            source: 'bing',
            views: 625,
          },
          {
            source: 'facebook',
            views: 244,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T17:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 8881,
          },
          {
            source: 'google',
            views: 2468,
          },
          {
            source: 'facebook',
            views: 1277,
          },
          {
            source: 'yahoo',
            views: 576,
          },
          {
            source: 'bing',
            views: 290,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T18:00:00+00:00',
        views: [
          {
            source: 'google',
            views: 3100,
          },
          {
            source: '(direct)',
            views: 2239,
          },
          {
            source: 'facebook',
            views: 963,
          },
          {
            source: 'bing',
            views: 542,
          },
          {
            source: 'yahoo',
            views: 490,
          },
        ],
      },
      {
        utc_hour: '2025-02-11T19:00:00+00:00',
        views: [
          {
            source: '(direct)',
            views: 8645,
          },
          {
            source: 'google',
            views: 2443,
          },
          {
            source: 'facebook',
            views: 1293,
          },
          {
            source: 'yahoo',
            views: 756,
          },
          {
            source: 'bing',
            views: 513,
          },
        ],
      },
    ],
  },
};

export const pieChartData = {
  widget: {
    id: 'insights.trafficsource',
    title: 'Traffic Source',
    updated: '2024-08-29T22:36:38+00:00',
    type: 'system',
    module: {
      id: 'trafficsource',
      title: 'Traffic Source',
      app: 'insights',
      parameters: {
        startDate: {
          type: 'str',
          label: 'Start Date',
          required: false,
          multiple: false,
        },
        endDate: {
          type: 'str',
          label: 'End Date',
          required: false,
          multiple: false,
        },
        hostname: {
          type: 'str',
          label: 'Hostname',
          required: false,
          multiple: false,
        },
        page: {
          type: 'integer',
          label: 'Page',
          required: false,
          multiple: false,
          min: 0,
          max: 1000,
          step: 1,
          default: 1,
        },
        pageSize: {
          type: 'integer',
          label: 'Page Size',
          required: false,
          multiple: false,
          min: 10,
          max: 100,
          step: 1,
          default: 10,
        },
        sumOthers: {
          type: 'boolean',
          label: 'Sum Other Sources',
          required: false,
          multiple: false,
          default: false,
        },
        refresh: '120',
      },
      data: {
        label: {
          type: 'string',
          label: 'Label',
        },
        id: {
          type: 'string',
          label: 'ID',
        },
        page_views: {
          type: 'integer',
          label: 'Pageviews',
        },
      },
      display: {
        options: [
          {
            type: 'pie',
            config: {
              'source-field': 'page_views',
            },
          },
        ],
        default: 'pie',
      },
    },
    parameters: {
      startDate: '-7 days',
      endDate: 'yesterday',
      hostname: 'example.com',
      page: 1,
      pageSize: 10,
      sumOthers: true,
      refresh: '120',
    },
    display: {
      view: 'pie',
      options: { options: [] } as any,
    },
  },
  data: {
    status: 'success',
    widget_id: 'insights.trafficsource',
    results_id: 'aa1e1402-6714-11ef-b876-93c9579fba86',
    total: 1,
    limit: 10,
    offset: 0,
    results: [
      {
        label: 'First Label',
        id: '0',
        page_views: 72,
      },
      {
        label: 'Second Label',
        id: '1',
        page_views: 28,
      },
    ],
  },
};

export const funnelChartData = {
  widget: {
    id: 'subscription.audiencesizes',
    title: 'Audience+ Audience Sizes',
    updated: '2024-06-28T14:58:00+00:00',
    type: 'system',
    module: {
      id: 'audiencesizes',
      title: 'Audience+ Audience Sizes',
      app: 'subscription',
      parameters: {
        startDate: {
          type: 'str',
          label: 'Start Date',
          required: false,
          multiple: false,
        },
        endDate: {
          type: 'str',
          label: 'End Date',
          required: false,
          multiple: false,
        },
        hostname: {
          type: 'str',
          label: 'Hostname',
          required: false,
          multiple: false,
        },
        refresh: '120',
      },
      data: {
        audience: {
          type: 'string',
          label: 'Audience',
        },
        users: {
          type: 'integer',
          label: 'Users',
        },
      },
      display: {
        options: [
          {
            type: 'funnel',
            config: {
              label: 'audience',
              value: 'users',
            },
          },
          {
            type: 'table',
          },
        ],
        default: 'funnel',
      },
    },
    parameters: {
      startDate: '-31 days',
      endDate: 'yesterday',
      hostname: 'example.com',
      refresh: '120',
    },
    display: {
      view: 'funnel',
      options: { options: [] } as any,
    },
  },
  data: {
    status: 'success',
    widget_id: 'subscription.audiencesizes',
    results_id: 'e25d8fb8-1904-11ef-b876-efbad47e49d3',
    total: 5,
    limit: false,
    offset: 0,
    results: [
      {
        users: 92095,
        audience: 'Sent',
      },
      {
        users: 83733,
        audience: 'Viewed',
      },
      {
        users: 76774,
        audience: 'Clicked',
      },
      {
        users: 65099,
        audience: 'Subscribed',
      },
      {
        users: 55397,
        audience: 'Purchased',
      },
    ],
  },
};

export const lineChartData = {
  widget: {
    id: 'insights.views',
    title: 'Views',
    updated: '2024-06-28T21:26:47+00:00',
    type: 'system',
    module: {
      id: 'views',
      title: 'Views',
      app: 'insights',
      parameters: {
        startDate: {
          type: 'str',
          label: 'Start Date',
          required: false,
          multiple: false,
        },
        endDate: {
          type: 'str',
          label: 'End Date',
          required: false,
          multiple: false,
        },
        hostname: {
          type: 'str',
          label: 'Hostname',
          required: false,
          multiple: false,
        },
        period: {
          type: 'enumeration',
          label: 'Period',
          required: false,
          multiple: false,
          options: [
            {
              id: 'daily',
              label: 'Daily',
            },
            {
              id: 'weekly',
              label: 'Weekly',
            },
            {
              id: 'monthly',
              label: 'Monthly',
            },
          ],
          default: 'daily',
        },
        refresh: '120',
      },
      data: {
        date: {
          type: 'string',
          label: 'Date',
          date_format: 'Y-m-d',
        },
        page_views: {
          type: 'integer',
          label: 'Pageviews',
        },
        article_page_views: {
          type: 'integer',
          label: 'Article Pageviews',
        },
      },
      display: {
        options: [
          {
            type: 'line',
            config: {
              'x-col': 'date',
              'x-display-format': 'M-d',
              'y-col': 'page_views',
              'y-display-format': '',
              subtype: 'area',
            },
          },
        ],
        default: 'line',
      },
    },
    parameters: {
      startDate: '-30 days',
      endDate: 'yesterday',
      hostname: 'example.com',
      period: 'daily',
      refresh: '120',
    },
    display: {
      view: 'line',
      options: { options: [] } as any,
    },
  },
  data: {
    status: 'success',
    widget_id: 'insights.views',
    results_id: 'e25d8fb8-1904-11ef-b876-efbad47e49d3',
    total: 19,
    limit: false,
    offset: 0,
    results: [
      {
        date: '2024-04-23',
        page_views: 16,
        article_page_views: 5,
      },
      {
        date: '2024-04-24',
        page_views: 19,
        article_page_views: 6,
      },
      {
        date: '2024-04-25',
        page_views: 49,
        article_page_views: 20,
      },
      {
        date: '2024-04-26',
        page_views: 5,
        article_page_views: 1,
      },
      {
        date: '2024-04-29',
        page_views: 6,
        article_page_views: 1,
      },
      {
        date: '2024-04-30',
        page_views: 5,
        article_page_views: 1,
      },
      {
        date: '2024-05-01',
        page_views: 62,
        article_page_views: 31,
      },
      {
        date: '2024-05-02',
        page_views: 1,
        article_page_views: 0,
      },
      {
        date: '2024-05-03',
        page_views: 8,
        article_page_views: 1,
      },
      {
        date: '2024-05-06',
        page_views: 21,
        article_page_views: 2,
      },
      {
        date: '2024-05-07',
        page_views: 6,
        article_page_views: 2,
      },
      {
        date: '2024-05-08',
        page_views: 14,
        article_page_views: 7,
      },
      {
        date: '2024-05-09',
        page_views: 19,
        article_page_views: 7,
      },
      {
        date: '2024-05-14',
        page_views: 128,
        article_page_views: 56,
      },
      {
        date: '2024-05-15',
        page_views: 35,
        article_page_views: 15,
      },
      {
        date: '2024-05-16',
        page_views: 99,
        article_page_views: 54,
      },
      {
        date: '2024-05-17',
        page_views: 19,
        article_page_views: 15,
      },
      {
        date: '2024-05-20',
        page_views: 5,
        article_page_views: 1,
      },
      {
        date: '2024-05-21',
        page_views: 5,
        article_page_views: 1,
      },
    ],
  },
};

export const detailsCardData = {
  widget: {
    id: 'editorial.articledetails',
    title: 'Article Asset Details',
    type: 'system',
    app: 'editorial',
    module: {
      id: 'articledetails',
      title: 'Article Asset Details',
      app: 'editorial',
      parameters: {
        startDate: {
          type: 'datetime',
          name: 'startDate',
          label: 'Start Date',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: 'today -30 days',
          config: {
            relative: true,
            step: 'day',
            resolution: 'date',
          },
          access: {},
        },
        endDate: {
          type: 'datetime',
          name: 'endDate',
          label: 'End Date',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: 'yesterday',
          config: {
            relative: true,
            step: 'day',
            resolution: 'date',
          },
          access: {},
        },
        hostname: {
          type: 'text',
          name: 'hostname',
          label: 'Hostname',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: null,
          config: {
            format: 'hostname',
          },
          access: {},
        },
        platform: {
          type: 'enumeration',
          name: 'platform',
          label: 'Platform',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: null,
          config: {
            static: true,
            options: [
              {
                label: 'Web',
                value: 'web',
              },
              {
                label: 'App',
                value: 'app',
              },
            ],
            multiple: false,
            data_type: 'string',
          },
          access: {},
        },
        subscriberOnly: {
          type: 'boolean',
          name: 'subscriberOnly',
          label: 'Subscribers Only',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: false,
          config: {
            true_label: 'Yes',
            false_label: 'No',
          },
          access: {},
        },
        localOnly: {
          type: 'boolean',
          name: 'localOnly',
          label: 'Local Assets Only',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: false,
          config: {
            true_label: 'Yes',
            false_label: 'No',
          },
          access: {},
        },
        refreshInterval: {
          type: 'denum',
          name: 'refreshInterval',
          label: 'Refresh Interval',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: '0',
          config: {
            multiple: false,
            app: 'insights',
            resolver: 'refreshinterval',
          },
          access: {},
        },
        refresh: '120',
      },
      data: {
        articles_published: {
          type: 'integer',
          label: 'Articles Published',
        },
        article_views: {
          type: 'integer',
          label: 'Article Views',
        },
        avg_word_count: {
          type: 'integer',
          label: 'Average Word Count',
        },
        top_source: {
          type: 'string',
          label: 'Top Traffic Source',
        },
      },
      display: {
        options: [
          {
            name: 'detailscard',
            type: 'detailscard',
          },
        ],
        default: 'detailscard',
      },
    },
    restrictions: {
      allow: [],
      disallow: [],
    },
    parameters: {
      hostname: 'example.com',
      refresh: '86400',
    },
    display: {
      view: 'detailscard',
      options: { options: [] } as any,
    },
    advanced_required: false,
    updated: '2025-07-07T07:34:16+00:00',
  },
  data: {
    status: 'success',
    widget_id: 'editorial.articledetails',
    results_id: '062ccb40-c128-42a6-b6ce-155bc18b9873',
    total: 1,
    limit: 0,
    offset: 0,
    results: [
      {
        articles_published: 39422,
        article_views: 1564278,
        avg_word_count: 492,
        top_source: 'google',
      },
    ],
  },
};

export const kpiData = {
  widget: {
    id: 'subscription.meterstops',
    title: 'Meter Stops',
    type: 'system',
    app: 'subscription',
    module: {
      id: 'meterstops',
      title: 'Meter Stops',
      app: 'subscription',
      parameters: {
        startDate: {
          type: 'str',
          label: 'Start Date',
          required: false,
        },
        endDate: {
          type: 'str',
          label: 'End Date',
          required: false,
        },
        hostname: {
          type: 'str',
          label: 'Hostname',
          required: false,
        },
        platform: {
          type: 'enumeration',
          label: 'Platform',
          options: [
            {
              id: 'web',
              label: 'Web',
            },
            {
              id: 'app',
              label: 'App',
            },
          ],
        },
        assetUUID: {
          type: 'str',
          label: 'Asset UUID',
          required: false,
        },
        refresh: '120',
      },
      data: {
        meter_stops: {
          type: 'integer|double',
          label: 'Meter Stops',
        },
        prev_meter_stops: {
          type: 'integer|double',
          label: 'Previous Meter Stops',
        },
      },
      display: {
        options: [
          {
            name: 'kpi',
            type: 'kpi',
            config: {
              current: 'meter_stops',
              prior: 'prev_meter_stops',
              sentiment: 'standard',
            },
          },
        ],
        default: 'kpi',
      },
    },
    restrictions: {
      allow: [],
      disallow: [],
    },
    parameters: {
      hostname: 'example.com',
      refresh: '120',
    },
    display: {
      view: 'kpi',
      options: { options: [] } as any,
    },
    advanced_required: false,
    updated: '2025-07-02T19:45:30+00:00',
  },
  data: {
    status: 'success',
    widget_id: 'subscription.meterstops',
    results_id: 'f0114d56-138a-401f-975e-a171851bfe1d',
    total: 1,
    limit: 0,
    offset: 0,
    results: [
      {
        meter_stops: 177385,
        prev_meter_stops: 128422,
      },
    ],
  },
};

export const tableData = {
  widget: {
    id: 'subscription.servicerateid',
    title: 'Service Rate ID',
    type: 'system',
    app: 'subscription',
    module: {
      id: 'servicerateid',
      title: 'Service Rate ID',
      app: 'subscription',
      parameters: {
        refresh: '120',
        startDate: {
          type: 'str',
          label: 'Start Date',
          required: false,
        },
        endDate: {
          type: 'str',
          label: 'End Date',
          required: false,
        },
        hostname: {
          type: 'str',
          label: 'Hostname',
          required: false,
        },
        platform: {
          type: 'enumeration',
          label: 'Platform',
          options: [
            {
              id: 'web',
              label: 'Web',
            },
            {
              id: 'mobile',
              label: 'Mobile',
            },
          ],
        },
        rateName: {
          type: 'str',
          label: 'Rate Name',
          required: false,
        },
        serviceName: {
          type: 'str',
          label: 'Service Name',
          required: false,
        },
        sort: {
          type: 'enumeration',
          label: 'Sort',
          options: [
            {
              id: 'service',
              label: 'Service',
            },
            {
              id: 'total_subscribers',
              label: 'Total Subscribers',
            },
            {
              id: 'total_revenue',
              label: 'Total Revenue',
            },
            {
              id: 'new_subscribers',
              label: 'New Subscribers',
            },
            {
              id: 'new_revenue',
              label: 'New Revenue',
            },
          ],
          default: 'total_subscribers',
          required: false,
        },
        sortDir: {
          type: 'enumeration',
          label: 'Sort Direction',
          options: [
            {
              id: 'asc',
              label: 'Ascending',
            },
            {
              id: 'desc',
              label: 'Descending',
            },
          ],
          default: 'desc',
          required: false,
        },
      },
      data: {
        id: {
          type: 'string',
          label: 'ID',
        },
        service: {
          type: 'string',
          label: 'Service',
        },
        rate: {
          type: 'string',
          label: 'Rate',
        },
        term: {
          type: 'integer',
          label: 'Term',
        },
        price: {
          type: 'integer|double',
          label: 'Price',
        },
        total_subscribers: {
          type: 'integer|double',
          label: 'Total Subscribers',
        },
        new_subscribers: {
          type: 'integer|double',
          label: 'New Subscribers',
        },
        total_revenue: {
          type: 'integer|double',
          label: 'Total Revenue',
        },
        new_revenue: {
          type: 'integer|double',
          label: 'New Revenue',
        },
      },
      display: {
        options: [
          {
            name: 'table',
            type: 'table',
            config: {
              columns: [
                'service',
                'rate',
                'term',
                'price',
                'total_subscribers',
                'new_subscribers',
                'total_revenue',
                'new_revenue',
              ],
            },
          },
        ],
        default: 'table',
      },
    },
    restrictions: {
      allow: [],
      disallow: [],
    },
    parameters: {
      hostname: 'example.com',
      rateName: '',
      serviceName: '',
      refresh: '120',
    },
    display: {
      view: 'table',
      options: { options: [] } as any,
    },
    advanced_required: false,
    updated: '2025-07-02T19:45:30+00:00',
  },
  data: {
    status: 'success',
    widget_id: 'subscription.servicerateid',
    results_id: '6ccdb125-4e4a-47c0-9aa5-01c1d5e23496',
    total: 3,
    limit: 0,
    offset: 0,
    results: [
      {
        id: '+LfUmt4nNLF6a0Mi5wriyNcRlM4=',
        service: 'Digital Access',
        rate: '3-Month Promo',
        term: 90,
        price: 39.99000000000000198951966012828052043914794921875,
        total_subscribers: 168,
        new_subscribers: 45,
        total_revenue: 1799.549999999999954525264911353588104248046875,
        new_revenue: 1799.549999999999954525264911353588104248046875,
      },
      {
        id: 'Lp7BXGo0B3TuUGWqIacsuWsLBEE=',
        service: 'Digital Access',
        rate: '6-Month Promo',
        term: 180,
        price: 59.99000000000000198951966012828052043914794921875,
        total_subscribers: 122,
        new_subscribers: 28,
        total_revenue: 1679.720000000000027284841053187847137451171875,
        new_revenue: 1679.720000000000027284841053187847137451171875,
      },
      {
        id: 'tU5xS1honNYsGMaPg/kS/EoJipc=',
        service: 'Digital Access',
        rate: '1-Year Promo',
        term: 365,
        price: 69.9899999999999948840923025272786617279052734375,
        total_subscribers: 73,
        new_subscribers: 15,
        total_revenue: 1049.84999999999990905052982270717620849609375,
        new_revenue: 1049.84999999999990905052982270717620849609375,
      },
    ],
  },
};

export const bubbleChartData = {
  widget: {
    id: 'editorial.viewsbycontenttopic',
    title: 'Views by Content Topic',
    type: 'system',
    app: 'editorial',
    module: {
      id: 'viewsbycontenttopic',
      title: 'Views by Content Topic',
      app: 'editorial',
      parameters: [
        {
          type: 'datetime',
          name: 'startDate',
          label: 'Start Date',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: 'today -30 days',
          config: {
            relative: true,
            step: 'day',
            resolution: 'date',
          },
          access: {},
        },
        {
          type: 'datetime',
          name: 'endDate',
          label: 'End Date',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: 'yesterday',
          config: {
            relative: true,
            step: 'day',
            resolution: 'date',
          },
          access: {},
        },
        {
          type: 'text',
          name: 'hostname',
          label: 'Hostname',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: null,
          config: {
            format: 'hostname',
          },
          access: {},
        },
        {
          type: 'enumeration',
          name: 'platform',
          label: 'Platform',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: null,
          config: {
            static: true,
            options: [
              {
                label: 'Web',
                value: 'web',
              },
              {
                label: 'App',
                value: 'app',
              },
            ],
            multiple: false,
            data_type: 'string',
          },
          access: {},
        },
        {
          type: 'boolean',
          name: 'subscriberOnly',
          label: 'Subscribers Only',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: false,
          config: {
            true_label: 'Yes',
            false_label: 'No',
          },
          access: {},
        },
        {
          type: 'enumeration',
          name: 'sortDir',
          label: 'Sort Direction',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: 'desc',
          config: {
            static: true,
            options: [
              {
                label: 'Ascending',
                value: 'asc',
              },
              {
                label: 'Descending',
                value: 'desc',
              },
            ],
            multiple: false,
            data_type: 'string',
          },
          access: {},
        },
        {
          type: 'number',
          name: 'pageSize',
          label: 'Page Size',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: 10,
          config: {
            min: 5,
            max: 100,
            step: 1,
            format: 'integer',
          },
          access: {},
        },
        {
          type: 'denum',
          name: 'refresh',
          label: 'Refresh Inverval',
          required: false,
          sensitive: false,
          help: null,
          tooltip: null,
          icon: null,
          default: '0',
          config: {
            multiple: false,
            app: 'insights',
            resolver: 'refreshinterval',
          },
          access: {},
        },
      ],
      data: {
        keyword: {
          type: 'string',
          label: 'Content Topic',
        },
        views: {
          type: 'integer',
          label: 'Pageviews',
        },
      },
      display: {
        options: [
          {
            name: 'bubble',
            type: 'bubble',
            config: {
              label: 'keyword',
              value: 'views',
            },
          },
        ],
        default: 'bubble',
      },
    },
    restrictions: {
      allow: [],
      disallow: [],
    },
    parameters: {
      hostname: 'example.com',
      refresh: '86400',
    },
    display: {
      view: 'bubble',
      options: { options: [] } as any,
    },
    advanced_required: true,
    updated: '2025-07-21T22:26:52+00:00',
  },
  data: {
    status: 'success',
    widget_id: 'editorial.topcontentproducers',
    results_id: 'f36c6dd4-b023-4705-bc7d-310a3acf5936',
    total: 5,
    limit: 0,
    offset: 0,
    results: [
      {
        id: 'fLagZAaqx1EOMASMBBqSjOVyiMA=',
        producer: 'Jim Writer',
        assets: 4535,
        views: 418000,
        conversion_leads: 43,
      },
      {
        id: 'hlkhfC7vrdYXBJRujeFoHi2KCEk=',
        producer: 'Test Staff',
        assets: 1784,
        views: 381375,
        conversion_leads: 50,
      },
      {
        id: 'g8utGPIskehadzaR78hDqgkd0+o=',
        producer: 'Test Producer Media',
        assets: 2352,
        views: 272304,
        conversion_leads: 4,
      },
      {
        id: 'yse7trZ7ROoKuZfTSojk6ptNPWI=',
        producer: 'Jane Doe',
        assets: 2020,
        views: 102505,
        conversion_leads: 16,
      },
      {
        id: 'RcROsVRMgiwjQ2iGNXfMq75I+h8=',
        producer: 'Associated Press',
        assets: 2332,
        views: 57185,
        conversion_leads: 29,
      },
    ],
  },
};
